export default __webpack_public_path__ + "static/media/header-send-it.3d4032a3.svg";